import { useMutation } from '@tanstack/react-query'
import { useAuthStore } from '@/store/auth.store'
import { profileApi } from '../api/profile.api'
import type { UpdateProfilePayload, UsernameFormData } from '../types'

export function useUpdateProfile() {
  const setAuth = useAuthStore((s) => s.setAuth)
  const token = useAuthStore((s) => s.token)

  return useMutation({
    mutationFn: (data: UpdateProfilePayload) => profileApi.updateProfile(data),
    onSuccess: ({ data }) => {
      if (token) setAuth(data.data, token)
    },
  })
}

export function useUpdateUsername() {
  const setAuth = useAuthStore((s) => s.setAuth)
  const token = useAuthStore((s) => s.token)

  return useMutation({
    mutationFn: (data: UsernameFormData) => profileApi.updateUsername(data),
    onSuccess: ({ data }) => {
      if (token) setAuth(data.data, token)
    },
  })
}

export function useUploadAvatar() {
  const setAuth = useAuthStore((s) => s.setAuth)
  const token = useAuthStore((s) => s.token)

  return useMutation({
    mutationFn: (file: File) => profileApi.uploadAvatar(file),
    onSuccess: ({ data }) => {
      const currentUser = useAuthStore.getState().user
      if (currentUser && token) {
        setAuth({ ...currentUser, avatar_url: data.data.avatar_url }, token)
      }
    },
  })
}

export function useDeleteAccount() {
  const logout = useAuthStore((s) => s.logout)

  return useMutation({
    mutationFn: () => profileApi.deleteAccount(),
    onSuccess: () => logout(),
  })
}
